import { render, staticRenderFns } from "./ProductPriorityGrid.vue?vue&type=template&id=33615b8e&scoped=true&"
import script from "./ProductPriorityGrid.vue?vue&type=script&lang=ts&"
export * from "./ProductPriorityGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPriorityGrid.vue?vue&type=style&index=0&id=33615b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33615b8e",
  null
  
)

export default component.exports